import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useMemo,
} from "react";
import {
  Card,
  Row,
  Col,
  Button,
  Table,
  Tag,
  Upload,
  Flex,
  Tooltip,
  Typography,
  Pagination,
  Select,
} from "antd";
import {
  FileAddOutlined,
  InfoOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { errorMessage } from "../../../utils/notificationUtils";
import dayjs from "dayjs";
import { Spin } from "antd";
import MappingModal from "../Reconciliation/MappingModal";
import MappingViewModal from "../Reconciliation/MappingViewModal";
import { Divider } from "antd";
import { Radio } from "antd";
import { useReconciliationSSE } from "../../../hooks/useReconciliationSSE";
import { ROUTES } from "../../../utils/constants";
import { useNavigate } from "react-router-dom";
import { Badge } from "antd";
import ReconFileViewMoreModal from "./ReconFileViewMoreModal";
import {
  fetchProcessedFiles,
  getUploadInputList,
} from "../../../apis/reconciliationService";
import OPReconMappingModal from "../Reconciliation/OPReconMappingModal";
import OPReconMappingViewModal from "../Reconciliation/OPReconMappingViewModal";

const ReconciliationFileSSE = ({
  file,
  onUpdate,
}: {
  file: any;
  onUpdate: any;
}) => {
  useReconciliationSSE({
    fileType: file.fileType?.replace(" ", "_"),
    fileReconId: file.fileReconId,
    fileStatus: file.fileStatus,
    onUpdate,
  });
  return null;
};

interface Props {
  saveFileMapperData: any;
  setReconciliationFile: any;
  selectedFile: any;
  handleFileChange: any;
  handleRemoveFile: any;
  reconciliationFile: any;
  isFileMappingLoading: boolean;
  isDocumentUploading: boolean;
  documentUrl: string | null;
  loadingProcessedFileList: boolean;
  reconData: any;
  totalListCount: any;
  onPaginationChange: any;
  pagination: any;
  setPagination: any;
  // handleGetFileMapperByHospital: any;
  // viewMappingModalLoader: boolean;
  // showMapping: boolean;
  // hospitalColumns: any;
  // dbColumns: any;
  // showMappingModal: boolean;
  // setShowMappingModal: any;
  // viewMappingModal: boolean;
  // setViewMappingModal: any;
  // existingMappings: any;
  // handleUpdateMappings: any;
  // handleSaveMapping: any;
  setReconData: any;
  bodEod: any;
  selectedHospital: number | null;
  availableHospitals: { label: string; value: string | number }[];
}

const { Text } = Typography;

const ReconFileUpload = forwardRef<any, Props>(
  (
    {
      saveFileMapperData,
      setReconciliationFile,
      selectedFile,
      handleFileChange,
      handleRemoveFile,
      reconciliationFile,
      isFileMappingLoading,
      isDocumentUploading,
      documentUrl,
      reconData,
      totalListCount,
      loadingProcessedFileList,
      onPaginationChange,
      pagination,
      setPagination,
      // viewMappingModalLoader,
      // handleGetFileMapperByHospital,
      // showMapping,
      // showMappingModal,
      // setShowMappingModal,
      // hospitalColumns,
      // dbColumns,
      // viewMappingModal,
      // setViewMappingModal,
      // handleUpdateMappings,
      // existingMappings,
      // handleSaveMapping,
      setReconData,
      bodEod,
      selectedHospital,
      availableHospitals,
    },
    ref,
  ) => {
    const [mappings, setMappings] = useState<Record<string, string>>({});
    const [columnSequence, setColumnSequence] = useState<
      Record<string, number>
    >({});
    const [isMappingLoading, setIsMappingLoading] = useState<boolean>(false);
    const [sequenceTable, setSequenceTable] = useState<string[][]>([]);
    const [openReconFileViewMoreModal, setOpenReconFileViewMoreModal] =
      useState(false);

    const [
      isReconFileViewMoreModalDataLoading,
      setIsReconFileViewMoreModalDataLoading,
    ] = useState<boolean>(false);
    const [reconFileViewMoreModalData, setReconFileViewMoreModalData] =
      useState<any[]>([]);
    const [reconFileViewMoreDataTotal, setReconFileViewMoreDataTotal] =
      useState<number>(0);
    const navigate = useNavigate();
    const [selectedVisitType, setSelectedVisitType] = useState<string>("OP");
    const [availableRegisters, setAvailabelRegisters] = useState<any>([]);
    const [availableRegisterErrorMessage, setAvailableRegisterErrorMessage] =
      useState<any>(null);

    useEffect(() => {
      setAvailableRegisterErrorMessage(null);
      getUploadInput(selectedVisitType);
    }, [selectedVisitType]);

    // const availableRegisters = useMemo(() => {
    //   if (selectedVisitType === "OP") return ["OP_REGISTER"];
    //   if (selectedVisitType === "IP")
    //     return ["DISCHARGE_REGISTER", "ADMISSION_REGISTER", "CREDIT_REGISTER", "CONSOLIDATED_IP"];
    //   return [];
    // }, [selectedVisitType]);

    //     const availableRegisters = useMemo(() => {
    //   if (selectedVisitType === "OP") {
    //     return [
    //       { label: "OP_REGISTER", value: "OP_REGISTER" }
    //     ];
    //   }
    //   if (selectedVisitType === "IP") {
    //     return [
    //       { label: "DISCHARGE_REGISTER", value: "DISCHARGE_REGISTER" },
    //       { label: "ADMISSION_REGISTER", value: "ADMISSION_REGISTER" },
    //       { label: "CREDIT_REGISTER", value: "CREDIT_REGISTER" },
    //       { label: "CONSOLIDATED_REGISTER", value: "CONSOLIDATED_IP" }
    //     ];
    //   }
    //   return [];
    // }, [selectedVisitType]);

    // const handleResetData = () => {
    //   setIsMappingLoading(false);
    //   setSequenceTable([]);
    //   setMappings({});
    //   setColumnSequence({});
    // };

    // useImperativeHandle(ref, () => ({
    //   handleResetData,
    // }));

    // useEffect(() => {
    //   if (showMappingModal) {
    //     setMappings({});
    //   }
    // }, [showMappingModal]);

    // const handleRadioChange = (hospitalCol: string, selectedDbCol: string) => {
    //   setMappings((prev) => ({
    //     ...prev,
    //     [hospitalCol]: selectedDbCol,
    //   }));
    // };

    // const result: any = Object.entries(mappings)?.map(
    //   ([originalColumnName, mapping]) => {
    //     const [mappedColumnName, targetTableName] = mapping.split("~");
    //     return {
    //       originalColumnName,
    //       mappedColumnName,
    //       targetTableName: targetTableName === "null" ? null : targetTableName,
    //       targetColumnName: mappedColumnName,
    //       dataType: "VARCHAR",
    //       seqNo: columnSequence[originalColumnName] || null,
    //     };
    //   },
    // );

    // const saveMapping = async () => {
    //   try {
    //     const res = await handleSaveMapping({
    //       mappings: result,
    //       sequence: sequenceTable,
    //     });
    //     if (res) {
    //       setIsMappingLoading(false);
    //       setSequenceTable([]);
    //       setMappings({});
    //     }
    //   } catch (err) {
    //     setIsMappingLoading(false);
    //     setSequenceTable([]);
    //     setMappings({});
    //   }
    // };

    const fetchReconFileViewMoreModalData = async (payload: any) => {
      try {
        setIsReconFileViewMoreModalDataLoading(true);
        const response = await fetchProcessedFiles(payload);
        setReconFileViewMoreModalData(response?.data || []);
        setReconFileViewMoreDataTotal(response?.totalElements || 0);
      } catch (error: any) {
        const messageText =
          error?.message || "Failed to load process history for View More";
        errorMessage(messageText);
        setReconFileViewMoreModalData([]);
        setReconFileViewMoreDataTotal(0);
      } finally {
        setIsReconFileViewMoreModalDataLoading(false);
      }
    };

    const getUploadInput = async (selectedVisitType: string) => {
      try {
        if (selectedHospital) {
          const response = await getUploadInputList(
            selectedHospital,
            selectedVisitType,
          );
          setAvailabelRegisters(response?.data || []);
        } else {
          setAvailabelRegisters([]);
        }
        setAvailableRegisterErrorMessage(null);
      } catch (error: any) {
        console.error("Error in getting upload list", error);
        if (error?.response?.data?.message) {
          setAvailableRegisterErrorMessage(error?.response?.data?.message);
        } else {
          setAvailableRegisterErrorMessage(null);
        }
        setAvailabelRegisters([]);
      }
    };

    return (
      <>
        {reconData?.map((file: any, idx: any) =>
          file.fileStatus !== "COMPLETED" ? (
            <ReconciliationFileSSE
              key={file.fileReconId}
              file={file}
              onUpdate={(data: any) => {
                setReconData((prev: any) => {
                  const updated = [...prev];
                  updated[idx] = {
                    ...updated[idx],
                    ...data,
                    fileStatus: data.status,
                  };
                  return updated;
                });
              }}
            />
          ) : null,
        )}

        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          {/* Register Upload */}
          <Card
            title={
              <span
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <FileAddOutlined style={{ color: "rgb(0, 76, 143)" }} />
                Register to Upload
              </span>
            }
          >
            <Row style={{ marginTop: -8, marginBottom: 16 }}>
              <Col>
                <Flex align="center" gap={10}>
                  <Text strong>Visit Type:</Text>
                  {/* <Select
                    value={selectedVisitType}
                    onChange={setSelectedVisitType}
                    options={[
                      { label: "OP", value: "OP" },
                      { label: "IP", value: "IP" },
                    ]}
                    style={{ width: 200 }}
                  /> */}
                  .
                  <Radio.Group
                    value={selectedVisitType}
                    onChange={(e) => setSelectedVisitType(e.target.value)}
                  >
                    <Radio value="OP">OP</Radio>
                    <Radio value="IP">IP</Radio>
                  </Radio.Group>
                </Flex>
              </Col>
            </Row>

            <Row gutter={[16, 8]} align="middle">
              <Col>
                {selectedFile ? (
                  <Card
                    hoverable
                    bodyStyle={{
                      padding: "0 12px",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      overflowX: "auto",
                    }}
                    style={{
                      display: "inline-flex",
                      width: "fit-content",
                      maxWidth: "100%",
                      cursor: "pointer",
                      border: "1px solid #e5e5e5",
                      borderRadius: 10,
                      boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                    }}
                  >
                    <Text
                      strong
                      style={{
                        whiteSpace: "nowrap",
                        flexShrink: 0,
                      }}
                    >
                      {reconciliationFile?.label}
                    </Text>

                    <Flex
                      align="center"
                      gap={8}
                      style={{
                        flexShrink: 0,
                      }}
                    >
                      <Tooltip title={selectedFile.file.name}>
                        <Text
                          style={{
                            fontSize: 14,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {selectedFile.file.name}
                        </Text>
                      </Tooltip>

                      <Button onClick={handleRemoveFile} danger size="small">
                        Remove
                      </Button>
                    </Flex>
                  </Card>
                ) : (
                  <Row gutter={16}>
                    {availableRegisterErrorMessage && (
                      <Col>
                        <Card
                          bodyStyle={{
                            padding: "0 12px",
                            height: "36px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          style={{
                            display: "inline-flex",
                            width: "fit-content",
                            maxWidth: "100%",
                            borderRadius: 10,
                            backgroundColor: "#fff1f0", // light red bg
                            border: "1px solid #ffa39e", // red border
                          }}
                        >
                          <Text
                            style={{ color: "#cf1322", whiteSpace: "nowrap" }}
                          >
                            {availableRegisterErrorMessage}
                          </Text>
                        </Card>
                      </Col>
                    )}

                    {availableRegisters?.length > 0 &&
                      availableRegisters.map((register: any) => (
                        <Col key={register?.sourceFileType}>
                          <Card
                            hoverable
                            bodyStyle={{
                              padding: "0 12px",
                              height: "36px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "10px",
                            }}
                            style={{
                              display: "inline-flex",
                              width: "fit-content",
                              maxWidth: "100%",
                              cursor: "pointer",
                              border: "1px solid #e5e5e5",
                              borderRadius: 10,
                              boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                            }}
                            onClick={() => setReconciliationFile(register)}
                          >
                            <Text strong style={{ whiteSpace: "nowrap" }}>
                              {register?.label?.replace("_", " ")}
                            </Text>

                            <Upload
                              showUploadList={false}
                              beforeUpload={() => false}
                              onChange={(info) => {
                                setReconciliationFile(register);
                                handleFileChange(info);
                              }}
                            >
                              <UploadOutlined
                                style={{ fontSize: 18, color: "#00549D" }}
                              />
                            </Upload>
                          </Card>
                        </Col>
                      ))}
                  </Row>
                )}
              </Col>

              {/* Mapping */}
              {/* {reconciliationFile && (
                <Col>
                  <Flex align="center" gap={8}>
                    <Text strong>Mapping</Text>

                    <Tooltip title="Mapping links hospital columns to system fields">
                      <div
                        style={{
                          background: "#D51E1E",
                          borderRadius: "50%",
                          height: 16,
                          width: 16,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <InfoOutlined
                          style={{ color: "white", fontSize: 10 }}
                        />
                      </div>
                    </Tooltip>

                    <Text
                      style={{
                        color: "blue",
                        cursor: viewMappingModalLoader
                          ? "not-allowed"
                          : "pointer",
                        border: "1px solid #d9d9d9",
                        borderRadius: 6,
                        padding: "4px 12px",
                        pointerEvents: viewMappingModalLoader ? "none" : "auto",
                        opacity: viewMappingModalLoader ? 0.6 : 1,
                      }}
                      onClick={handleGetFileMapperByHospital}
                    >
                      {viewMappingModalLoader ? (
                        <Spin size="small" />
                      ) : (
                        <>{reconciliationFile?.split("_").join(" ")} Map</>
                      )}
                    </Text>
                  </Flex>
                </Col>
              )} */}

              {/* Upload Button */}
              <Col style={{ marginLeft: "10%" }}>
                <Button
                  type="primary"
                  icon={<UploadOutlined />}
                  style={{
                    backgroundColor:
                      isFileMappingLoading ||
                      isDocumentUploading ||
                      !documentUrl
                        ? "#00549D"
                        : "#00549D",
                    borderColor:
                      isFileMappingLoading ||
                      isDocumentUploading ||
                      !documentUrl
                        ? "#00549D"
                        : "#00549D",
                    color: "#fff",
                    opacity:
                      isFileMappingLoading ||
                      isDocumentUploading ||
                      !documentUrl
                        ? 0.6
                        : 1,
                    height: 36,
                  }}
                  onClick={saveFileMapperData}
                  loading={isFileMappingLoading || isDocumentUploading}
                  disabled={
                    isFileMappingLoading || isDocumentUploading || !documentUrl
                  }
                >
                  Upload
                </Button>
              </Col>
            </Row>
          </Card>

          {/* Recent Activity History */}
          <Card
            title="Recent Activity History"
            extra={
              <a
                onClick={() => {
                  setOpenReconFileViewMoreModal(true);
                }}
              >
                View More
              </a>
            }
          >
            <Table
              pagination={false}
              columns={[
                {
                  title: "Process Type",
                  dataIndex: "eodBodProcessType",
                  render: (value: any) => (value ? value : "-"),
                },
                {
                  title: "Register Type",
                  dataIndex: "fileType",
                  render: (value: any) => (value ? value : "-"),
                },
                {
                  title: "Updated By",
                  dataIndex: "updatedBy",
                  render: (value: any) => (value ? value : "-"),
                },
                {
                  title: "Timestamp",
                  dataIndex: "dateAndTime",
                  render: (_: any, record: any) => {
                    return record?.dateAndTime
                      ? dayjs(record.dateAndTime).format("DD-MM-YYYY hh:mm A")
                      : "-";
                  },
                },
                // {
                //   title: "Status",
                //   dataIndex: "fileStatus",
                //   render: (status: string) => (
                //     <Tag
                //       color={
                //         status?.toLowerCase() === "completed"
                //           ? "green"
                //           : "orange"
                //       }
                //       style={{
                //         borderRadius: "999px",
                //         padding: "2px 12px",
                //         display: "inline-flex",
                //         alignItems: "center",
                //         gap: 6,
                //       }}
                //     >
                //       <Badge
                //         color={
                //           status?.toLowerCase() === "completed"
                //             ? "green"
                //             : "orange"
                //         }
                //       />
                //       {status}
                //     </Tag>
                //   ),
                // },
                {
                  title: "Status",
                  dataIndex: "fileStatus",
                  render: (status: string, record: any) => {
                    const isFailed = status?.toLowerCase() === "failed";
                    const isCompleted = status?.toLowerCase() === "completed";

                    const tag = (
                      <Tag
                        color={
                          isCompleted ? "green" : isFailed ? "red" : "orange"
                        }
                        style={{
                          borderRadius: "999px",
                          padding: "2px 12px",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        <Badge
                          color={
                            isCompleted ? "green" : isFailed ? "red" : "orange"
                          }
                        />
                        {status}
                      </Tag>
                    );
                    return isFailed ? (
                      <Tooltip
                        title={record?.errorMessage || "No reason available"}
                      >
                        {tag}
                      </Tooltip>
                    ) : (
                      tag
                    );
                  },
                },
                {
                  title: <span style={{ marginLeft: 70 }}>Action</span>,
                  render: (_: any, record: any) => {
                    return (
                      <Flex gap={8}>
                        <span
                          style={{ cursor: "pointer", color: "#00549D" }}
                          onClick={() =>
                            window.open(
                              `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
                                record?.s3Url,
                              )}`,
                              "_blank",
                            )
                          }
                        >
                          View Registers
                        </span>

                        <span
                          style={{
                            cursor: "pointer",
                            color: "#00549D",
                            marginLeft: 10,
                          }}
                          onClick={() => {
                            sessionStorage.setItem("eod-active-tab", "2");
                            sessionStorage.setItem(
                              "selected-bod-eod-value",
                              bodEod,
                            );
                            if (
                              record?.fileType?.toLowerCase()?.includes("op")
                            ) {
                              navigate(`${ROUTES.OP_RECONCILIATION}`);
                            } else {
                              navigate(`${ROUTES.IP_RECONCILIATION}`);
                            }
                          }}
                        >
                          View Result
                        </span>
                      </Flex>
                    );
                  },
                },
              ]}
              dataSource={reconData}
              loading={loadingProcessedFileList}
            />

            <div
              style={{
                borderTop: "1px solid #f0f0f0",
                paddingTop: 20,
                height: 20,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Pagination
                size="small"
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={totalListCount}
                showSizeChanger
                pageSizeOptions={["10", "20", "50", "100"]}
                onChange={(page, pageSize) => {
                  setPagination({
                    current: page,
                    pageSize,
                  });
                  onPaginationChange(page, pageSize);
                }}
              />
            </div>

            {/* {!showMapping ? (
              <>
                <Table
                  pagination={false}
                  columns={[
                    {
                      title: "Process Type",
                      dataIndex: "eodBodProcessType",
                      render: (value: any) => (value ? value : "-"),
                    },
                    {
                      title: "Register Type",
                      dataIndex: "fileType",
                      render: (value: any) => (value ? value : "-"),
                    },
                    {
                      title: "Updated By",
                      dataIndex: "updatedBy",
                      render: (value: any) => (value ? value : "-"),
                    },
                    {
                      title: "Timestamp",
                      dataIndex: "dateAndTime",
                      render: (_: any, record: any) => {
                        return record?.dateAndTime
                          ? dayjs(record.dateAndTime).format(
                              "DD-MM-YYYY hh:mm A",
                            )
                          : "-";
                      },
                    },
                    {
                      title: "Status",
                      dataIndex: "fileStatus",
                      render: (status: string) => (
                        <Tag
                          color={
                            status?.toLowerCase() === "completed"
                              ? "green"
                              : "orange"
                          }
                          style={{
                            borderRadius: "999px",
                            padding: "2px 12px",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          <Badge
                            color={
                              status?.toLowerCase() === "completed"
                                ? "green"
                                : "orange"
                            }
                          />
                          {status}
                        </Tag>
                      ),
                    },
                    {
                      title: <span style={{ marginLeft: 70 }}>Action</span>,
                      render: (_: any, record: any) => {
                        return (
                          <Flex gap={8}>
                            <span
                              style={{ cursor: "pointer", color: "#00549D" }}
                              onClick={() =>
                                window.open(
                                  `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
                                    record?.s3Url,
                                  )}`,
                                  "_blank",
                                )
                              }
                            >
                              View Registers
                            </span>

                            <span
                              style={{
                                cursor: "pointer",
                                color: "#00549D",
                                marginLeft: 10,
                              }}
                              onClick={() => {
                                sessionStorage.setItem("eod-active-tab", "2");
                                sessionStorage.setItem(
                                  "selected-bod-eod-value",
                                  bodEod,
                                );
                                if (
                                  record?.fileType
                                    ?.toLowerCase()
                                    ?.includes("op")
                                ) {
                                  navigate(`${ROUTES.OP_RECONCILIATION}`);
                                } else {
                                  navigate(`${ROUTES.IP_RECONCILIATION}`);
                                }
                              }}
                            >
                              View Result
                            </span>
                          </Flex>
                        );
                      },
                    },
                  ]}
                  dataSource={reconData}
                  loading={loadingProcessedFileList}
                />

                <div
                  style={{
                    borderTop: "1px solid #f0f0f0",
                    paddingTop: 20,
                    height: 20,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <Pagination
                    size="small"
                    current={pagination.current}
                    pageSize={pagination.pageSize}
                    total={totalListCount}
                    showSizeChanger
                    pageSizeOptions={["10", "20", "50", "100"]}
                    onChange={(page, pageSize) => {
                      setPagination({
                        current: page,
                        pageSize,
                      });
                      onPaginationChange(page, pageSize);
                    }}
                  />
                </div>
              </>
            ) : (
              <Card bordered>
                <Flex
                  align="center"
                  justify="space-between"
                  style={{ marginBottom: 12 }}
                >
                  <Text strong style={{ fontSize: 16 }}>
                    Mapping
                  </Text>
                  <Text type="secondary">
                    Map hospital columns to database columns
                  </Text>
                </Flex>
                <Divider style={{ margin: "8px 0 16px" }} />

                <Row gutter={16} style={{ marginBottom: 8 }}>
                  <Col xs={24} md={6}>
                    <Text type="secondary">Hospital Column</Text>
                  </Col>
                  <Col xs={24} md={18}>
                    <Text type="secondary">Select matching DB column</Text>
                  </Col>
                </Row>

                <div
                  style={{ maxHeight: 360, overflowY: "auto", paddingRight: 8 }}
                >
                  {hospitalColumns?.map((hospitalCol: any, idx: any) => {
                    const usedSequenceNumbers = Object.values(columnSequence);
                    const availableSequenceNumbers = Array.from(
                      { length: hospitalColumns.length },
                      (_, i) => i + 1,
                    );
                    return (
                      <div key={hospitalCol + "~" + idx}>
                        <Row
                          align="middle"
                          gutter={[16, 12]}
                          style={{ marginBottom: 8 }}
                        >
                          <Col xs={24} md={6}>
                            <Text style={{ fontWeight: 500 }}>
                              {hospitalCol}
                            </Text>
                          </Col>
                          <Col xs={24} md={18}>
                            <Radio.Group
                              onChange={(e) =>
                                handleRadioChange(hospitalCol, e.target.value)
                              }
                              value={mappings[hospitalCol]}
                              buttonStyle="solid"
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 8,
                              }}
                            >
                              {dbColumns?.map((dbCol: any) => (
                                <Radio.Button
                                  key={`${hospitalCol}~${dbCol?.mappedColumnData}~${dbCol?.targetTableName}~${idx}`}
                                  value={
                                    dbCol?.mappedColumnData +
                                    "~" +
                                    dbCol?.targetTableName
                                  }
                                  style={
                                    mappings[hospitalCol] ===
                                    dbCol?.mappedColumnData +
                                      "~" +
                                      dbCol?.targetTableName
                                      ? {
                                          backgroundColor: "rgb(0, 76, 143)",
                                          color: "#fff",
                                          borderColor: "rgb(0, 76, 143)",
                                        }
                                      : undefined
                                  }
                                >
                                  {dbCol.mappedColumnData?.toUpperCase() ===
                                    "op_number"?.toUpperCase() ||
                                  dbCol.mappedColumnData?.toUpperCase() ===
                                    "opNumber"?.toUpperCase()
                                    ? "OP/IP_Number"
                                    : dbCol.mappedColumnData}
                                </Radio.Button>
                              ))}
                            </Radio.Group>
                          </Col>
                        </Row>
                        {idx < hospitalColumns.length - 1 && (
                          <Divider dashed style={{ margin: "12px 0" }} />
                        )}
                      </div>
                    );
                  })}
                </div>

                <Button
                  type="primary"
                  style={{
                    backgroundColor: "rgb(0, 76, 143)",
                    boxShadow: "0px 2px 8px 0px #00000040",
                  }}
                  onClick={saveMapping}
                  loading={isMappingLoading}
                >
                  Save
                </Button>
              </Card>
            )} */}
          </Card>

          {/* <OPReconMappingModal
            handleRadioChange={handleRadioChange}
            mappings={mappings}
            columnSequence={columnSequence}
            setColumnSequence={setColumnSequence}
            saveMapping={saveMapping}
            open={showMappingModal}
            onClose={() => setShowMappingModal(false)}
            hospitalColumns={hospitalColumns}
            dbColumns={dbColumns}
          />

          <OPReconMappingViewModal
            open={viewMappingModal}
            onClose={() => setViewMappingModal(false)}
            existingMappings={existingMappings}
            dbColumns={dbColumns}
            onSave={handleUpdateMappings}
          /> */}

          <ReconFileViewMoreModal
            open={openReconFileViewMoreModal}
            onClose={() => setOpenReconFileViewMoreModal(false)}
            availableHospitals={availableHospitals || []}
            selectedHospital={selectedHospital}
            isReconFileViewMoreModalDataLoading={
              isReconFileViewMoreModalDataLoading
            }
            viewMoreModalData={reconFileViewMoreModalData}
            fetchReconFileViewMoreModalData={fetchReconFileViewMoreModalData}
            viewMoreDataTotal={reconFileViewMoreDataTotal}
          />
        </div>
      </>
    );
  },
);

export default ReconFileUpload;
